module.exports = __webpack_public_path__ + "static/media/NotoSans-Italic.1636df07.woff2";